/**
 * Protected Route Component for NWGSV Command System
 * Redirects to login if user is not authenticated
 */
import { Navigate } from 'react-router-dom';
import { useAuth, UserRole } from '../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactElement;
  requireRole?: UserRole[];
}

export default function ProtectedRoute({ children, requireRole }: ProtectedRouteProps) {
  const { user, loading } = useAuth();

  // Show loading while checking auth
  if (loading || user === undefined) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        background: 'black',
        color: '#FFD700',
        fontSize: '18px',
        fontWeight: 'bold',
        letterSpacing: '2px',
      }}>
        AUTHENTICATING...
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Check role requirement if specified
  if (requireRole && !requireRole.includes(user.role)) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        gap: '20px',
        minHeight: '100vh',
        background: 'black',
        color: '#FFD700',
        padding: '20px',
        textAlign: 'center',
      }}>
        <div style={{ fontSize: '24px', fontWeight: 'bold' }}>ACCESS DENIED</div>
        <div style={{ fontSize: '14px', opacity: 0.7 }}>
          Required role: {requireRole.join(' or ')}
        </div>
        <div style={{ fontSize: '14px', opacity: 0.7 }}>
          Your role: {user.role}
        </div>
      </div>
    );
  }

  return children;
}
